import { useTraderWallets } from '@entities/trades/wallet';
import type { ITraderWalletTableColumns } from '@entities/trades/wallet';
import { useRefetchAuto } from '@features/refetch-auto';
import ErrorMessage from '@shared/components/ErrorMessage';
import Loading from '@shared/components/Loading';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import { Pagination, PaginationRows } from '@shared/components/Pagination';
import { Table, THead, TBody, TableContainer, TableProvider } from '@shared/components/Table';

import { useTableSettings } from './settings/useTableSettings';

const WalletsWidget = () => {
  const { refreshInterval, setRefreshInterval } = useRefetchAuto({
    storageKey: 'refetch-auto-trader-wallets',
  });

  const {
    traderWallets,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,

    filter,
  } = useTraderWallets({ refreshInterval });

  const { columnTitles, renderRow, renderFilterElement, getTheadAfter, getTbodyAfter } =
    useTableSettings({
      refetch,
      refreshInterval,
      setRefreshInterval,
    });

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorMessage error={error} />;

  if (traderWallets) {
    return (
      <>
        {isFetching && <Loading />}

        <TableProvider<ITraderWalletTableColumns>
          columnTitles={columnTitles}
          storageKey='trader-wallets'
          {...filter}
        >
          <TableContainer>
            <Table>
              <THead
                items={traderWallets.data}
                renderItem={renderFilterElement}
                afterColumns={getTheadAfter}
              />
              <TBody
                items={traderWallets.data}
                renderItem={renderRow}
                afterColumns={getTbodyAfter}
              />
            </Table>
          </TableContainer>
          <div className='pagination-container'>
            <Pagination data={traderWallets.meta} />
            <PaginationRows />
          </div>
        </TableProvider>
      </>
    );
  }

  return null;
};

export default WalletsWidget;
